import React, { useState, useEffect } from 'react';
import rolls from './assets/rolls.png';
import rollsBack from './assets/roloR2.png';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import About from './About';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './Home';
import BookRide from './BookRide';
import BecomeDriver from './BecomeDriver';
import Safety from './safety';

import CareerPage from './CareerPage';
import JobPost from './JobPost';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Blog from './blog';
import FAQ from './FAQ';
import HelpCenter from './HelpCenter';
import Terms from './Terms';
import Privacy from './Privacy';
import DeleteAccount from './DeleteAccount';



function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [activeSlide, setActiveSlide] = useState(0);

  const slides = [
    {
      title: "Competitive pricing across Micro, <br/> Mini, Sedan, SUV, Bike",
      subtitle: "Affordable rides",
      image: rolls
    },
    {
      title: "Pick-drop, carpooling, deliveries, <br/> and more  all in one app",
      subtitle: "Diverse Services",
      image: rolls
    },
    {
      title: " Real-time tracking, verified drivers, <br/> and emergency support",
      subtitle: "Ride Safely",
      image: rolls
    },
    {
      title: "We promote carpooling and <br/> electric vehicles for a <br/> greener planet",
      subtitle: "Experience Eco-friendly Rides",
      image: rolls
    }
  ];

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/book-ride" element={<BookRide />} />
        <Route path="/become-driver" element={<BecomeDriver/>} />
        <Route path='/safety' element={<Safety />} />
        <Route path='/help-center' element={<HelpCenter />} />
        <Route path='/careers' element={<CareerPage />} />
        <Route path="/job/:id" element={<JobPost />} />
        <Route path="/blog" element={<Blog/>} />
        <Route path='/faq' element={<FAQ/>} />
        <Route path='/privacy' element={<Privacy/>} />
        <Route path='/terms' element={<Terms/>} />
        <Route path='/delete-account' element={<DeleteAccount/>}/>
      </Routes>

       <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      pauseOnHover
      theme="dark"
    />
    </>
  );
}

export default App;
